<template>

	<div class="container main-content">
			
		<div class="row mb-2 mb-md-5">
			<div class="col-sm-12 col-md-6 text-center text-md-right">
				<img :src="gcImage" :alt="$gstate.getPaymentMethodSubtypeName(this.$gstate.getPaymentMethodSubtype()) + ' eGift Card'">
			</div>
			<div class="col-sm-12 col-md-6 text-center text-md-left mt-4 mt-md-0">
				<div class="row">
					<div class="col-12">
						<h3 class="mb-0">{{ $gstate.getPaymentMethodSubtypeName(this.$gstate.getPaymentMethodSubtype()) }} eGift Card</h3>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div v-bind:class="{ processing: isProcessing }">
							<span class="large-inputs large-inputs-fiat spend-large-input pr-3">${{ pq.fiatAmount | num2decimal }}&nbsp;<span class="large-inputs-suffix">{{ pq.fiatCurrency }}</span></span>
							
						</div>
					</div>
				</div>
				<div class="row text-center mt-2">
					<div class="col-sm-12">
						<ul class="gc-info-links text-center text-md-left">
							<li v-if="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).website !== undefined">Website: <a target="_blank" :href="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).website">{{ cleanURL($gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).website) }}</a></li>
							<li v-if="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).faqURL !== undefined">FAQ: <a target="_blank" :href="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).faqURL">Read more <i class="fas fa-external-link-square-alt"></i></a></li>
							<li v-if="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).termsURL !== undefined">Terms: <a target="_blank" :href="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).termsURL">Read more <i class="fas fa-external-link-square-alt"></i></a></li>
							<li v-if="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).termsCopy !== undefined">Terms: <a href="#" @click.prevent="showTermsModal = true">Read more</a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div class="row text-center">
			<div class="col-12">
				<div class="d-inline-block">
					<button v-for="(value, index) in amounts" v-bind:key="index" href="#" :disabled="isProcessing" v-bind:class="[{ 'btn-rounded-spend-active' : value == pq.fiatAmount },'btn btn-rounded btn-rounded-spend mt-2']" @click.prevent="updateFiatAmount(value)">${{ value }}</button>
					<div class="shadow mt-4">
					</div>
				</div>
			</div>
		</div>

		<div class="row text-center mb-3">
			<div class="col-sm-12">
				<p v-bind:class="{ processing: isProcessing }">
					<span class="spend-crypto-msg">This eGift Card will cost you <span class="spend-crypto">{{ pq.cryptoAmount | num8decimal }}</span>&nbsp;{{ pq.cryptoCurrency }}</span>
				</p>
			</div>
		</div>
		

		<div class="row text-center">
			<div class="col-sm-12">
				<p class="spend-crypto-rate">
					<span class="d-block mb-0">1&nbsp;{{ pq.cryptoCurrency }} = {{ $gstate.getCurrencySymbol(pq.fiatCurrency) }} {{ ( pq.fiatAmount / pq.cryptoAmount ) | num2decimal }} {{ pq.fiatCurrency }}</span>
				</p>
			</div>
		</div>

		<div class="row mb-4 mt-2 pb-2">
			<div class="col-12 col-md-4 offset-md-4 text-center">
				<p>By continuing, you agree and consent to the <a target="_blank" v-bind:href="tosURL">Terms of Service</a> and <a target="_blank" v-bind:href="ppURL">Privacy Policy</a></p>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center">
				<a href="#" id="price-quote-next" v-if="!isProcessing" class="btn next-btn" :class="{'disabled' : isProcessingRequote }" ref="btnNext" v-on:click.prevent="confirm">NEXT</a>
                <a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
			</div>
		</div>

		<cc-modal v-if="showTermsModal" @action="modalAction" close="Back">
			<p slot="body" v-if="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).termsCopy !== undefined" v-html="$gstate.getPaymentMethodSubtypeObj($gstate.getPaymentMethodSubtype()).termsCopy"></p>
		</cc-modal>
	</div>

</template>

<script>

import { eventBus } from './../main'

export default {
    mounted() {

		this.$gstate.log("refId: " + this.pq.refId);

		this.$refs.btnNext.focus();
		this.$emit('setRateHoldTimer', true);
		this.$emit('setLeaveNotification', true);

		if(this.$gstate.isProd()){
			this.logUserAgent();
		}

    },
    data() {
        return {
			pq: this.$gstate.getFlowState(),
			isProcessingRequote: false,
			isProcessing: false,
			hasError: false,
			errorMessage: '',
			showModal: false,
			showTermsModal: false,
			newPq: {},
			amounts: this.$gstate.getPaymentMethodSubtypeAmounts(this.$gstate.getPaymentMethodSubtype())
        }
	},
	computed: {
        tosURL: function() {

			var urlstr = this.$gstate.getSiteURL() + '/terms-of-service';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/terms-of-service";
			}

			return urlstr;
            
		},
		ppURL: function() {
			
            var urlstr = this.$gstate.getSiteURL() + '/privacy-policy';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/privacy-policy";
			}

			return urlstr;
		},
		gcImage: function(){
			return '/static/img/sell/' + this.$gstate.getPaymentMethodSubtype() + '.png';
		}
    },
	created(){
		eventBus.$on('nextScreen', this.confirm);
		eventBus.$on('refreshPq', this.refreshPq);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.confirm);
		eventBus.$off('refreshPq', this.refreshPq);
	},
    methods: {
        confirm: function() {
			eventBus.$emit('logGTMTransactionEvent', "transactionCreated");
            this.$router.push('buyer-info-input');
		},
		refreshPq: function (){
			this.pq = this.$gstate.getFlowState();
		},
		logUserAgent(){

			var data = new FormData();
			data.append('refId', this.$gstate.getRefId());
			data.append('width', window.screen.width);
			data.append('height', window.screen.height);

			var urlstr = 'https://coincurve.com/user-agent.php';
			this.axios.post(urlstr, data, this.$gstate.getAxiosHeaders())
				// eslint-disable-next-line
				.then(response => {
					
				})
				// eslint-disable-next-line
				.catch(error => {
					
				});
		},
		updateFiatAmount(newAmount){

			var urlstr = this.$gstate.getApiBaseURL() + '/requote';
			var data = {
					refId: this.pq.refId,
					fiatAmount: newAmount,
					fiatCurrency: this.pq.fiatCurrency,
					cryptoCurrency: this.pq.cryptoCurrency,
					paymentMethod: this.$gstate.getPaymentMethod(),
					paymentMethodSubtype: this.$gstate.getPaymentMethodSubtype(),
					txnType: this.$gstate.getTxnType(),
					country: this.$gstate.getActiveCountry()
				};

			this.isProcessing = true;
			
			this.axios.post(urlstr, data, this.$gstate.getAxiosHeaders())
				.then(response => {
					this.isProcessing = false;

					// update transaction details
					// and save data to global state
					this.pq = this.$gstate.getFlowState();
					this.pq.fiatAmount = newAmount;
					this.pq.cryptoAmount = response.data.cryptoAmount;
					this.pq.txnValidUntil = response.data.txnValidUntil;
					this.pq.forexRatePublic = response.data.forexRatePublic;
					this.pq.txnDate = response.data.txnDate;
					this.$gstate.saveFlowState(this.pq);
					
				})
				// eslint-disable-next-line
				.catch(error => {
					this.$toasted.error('Woops. Something went wrong. Please try again.');
				});

		},
		modalAction: function(action){
			if(action == "close"){
				this.showTermsModal = false;
			}
		},
		cleanURL: function(url){
			return url.replace(/(^\w+:|^)\/\//, '');
		}
		
    }
}
</script>
<style>

.processing{
	opacity: 0.2;
}

.fa-external-link-square-alt{
	font-size: .8em;
}

.gc-info-links{
	list-style: none;
	padding-left: 0px;
	font-size: .8em;
}

</style>